import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name:       'formatNumber',
  standalone: true
})
export class FormatNumberPipe implements PipeTransform {
  transform(value: any, arg: string): any {
    if (!value) {
      return value;
    }

    if (arg === 'polizze') {
      value = value.replace(/^0+/, '');
      return this.formatPolizzenTeil(value);
    }
    if (arg === 'schaden') {
      value = value.replace(/^0+/, '');
      const polizzenNummerTeil = value.substring(0, value.length - 8);
      const schadenNummernTeil = value.substring(value.length - 8);

      return (
        this.formatPolizzenTeil(polizzenNummerTeil) +
        ' ' +
        schadenNummernTeil.substring(0, schadenNummernTeil.length - 4) +
        '-' +
        schadenNummernTeil.substring(schadenNummernTeil.length - 4)
      );
    }

    if (arg === 'removeLeadingZeros') {
      return value.replace(/^0+/, '');
    }

    return '';
  }

  private formatPolizzenTeil(value: string): string {
    const polizzenNummerTeil1 = value.substring(0, value.length - 1);
    const polizzenNummerTeil2 = value.substring(value.length - 1);

    const nf = new Intl.NumberFormat('de-DE');
    return nf.format(+polizzenNummerTeil1) + '/' + polizzenNummerTeil2;
  }
}
